import React from 'react';
import { ChangeData } from '../../services/model';

const onClick = (changeId: string) => {
    window.location.href = '#' + changeId;
};

export const Change: React.FC<ChangeData> = ({ changeId, description, scope, isCompliant }) => (
    <tr onClick={() => onClick(changeId)} className="selectable" title={description}>
        <th scope="row">{scope}</th>
        <td>{description}</td>
        <td>{isCompliant ? '✅' : '❌'}</td>
    </tr>
);
